import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { Navigate } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { MasterLayout } from './components/MasterLayout';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap';
import 'primereact/resources/primereact.css';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import './index.css';
import Explorer from './paths/Explorer';
import Collections from './paths/Collections';
import Tags from './paths/Tags';
import Annotator from './paths/Annotator';
import AnnotatorV1 from './paths/AnnotatorV1';
import { PrimeReactProvider } from 'primereact/api';
import { ExplorerV2 } from './paths/Explorer.v2';
import { Provider } from 'react-redux';
import { store } from './common_functions/store';
// import Register from './paths/Register';
import User from './paths/User';
import Dashboard from './paths/Dashboard';
import { useDispatch } from "react-redux";
import { setLoginUser } from './common_functions/store';
import Agents from './paths/Agents';
import Datasets from './paths/Datasets';
import Models from './paths/Models';
// import ProfilePage from './paths/Profile';

// Authentication Wrapper Component
const AuthGuard = ({ children, roles }) => {
  const token = localStorage.getItem('authToken');
  const userrole = localStorage.getItem('role');
  const userName = localStorage.getItem('username');
  const dispatch = useDispatch();

  useEffect(()=>{
    dispatch(setLoginUser({
        authToken:token,
        role:userrole,
        userName:userName
      }));
  },[])

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  if (!userrole || (userrole && (roles && roles.length>0 && (roles.filter(role=>role==userrole)).length==0))) {
    return <Navigate to="/explorer" replace />;
  }

  return children;
};

const BrowserRouter = createBrowserRouter([
  {
    path: '/',
    element: <MasterLayout />,
    children: [
      {
        path: '/explorer',
        element: (
          <AuthGuard>
            <Explorer />
          </AuthGuard>
        ),
      },
      {
        path: '/explorer/v2',
        element: (
          <AuthGuard>
            <ExplorerV2 />
          </AuthGuard>
        ),
      },
      {
        path: '/collections',
        element: (
          <AuthGuard>
            <Collections />
          </AuthGuard>
        ),
      },
      {
        path: '/tags',
        element: (
          <AuthGuard>
            <Tags />
          </AuthGuard>
        ),
      },
      {
        path: '/agents',
        element: (
          <AuthGuard>
            <Agents />
          </AuthGuard>
        ),
      },
      {
        path: '/models',
        element: (
          <AuthGuard>
          <Models />
          </AuthGuard>
        ),
      },
      {
        path: '/datasets',
        element: (
          <AuthGuard>
            <Datasets />
          </AuthGuard>
        ),
      },
      {
        path: '/admin',
        element: (
          <AuthGuard roles={['admin']}>
            <Dashboard />
          </AuthGuard>
        ),
      },
      // {
      //   path: '/profile',
      //   element: (
      //     <AuthGuard roles={['admin']}>
      //       <ProfilePage />
      //     </AuthGuard>
      //   ),
      // },
    ],
  },
  {
    path: '/login',
    element: <User />,
  },
  {
    path: '/forgot-password',
    element: <User />,
  },
  {
    path: '/validate-otp',
    element: <User />,
  },
  {
    path: '/update-password',
    element: <AuthGuard>
      <User />
    </AuthGuard>,
  },
  {
    path: '/reset-password',
    element: <User />,
  },
  {
    path: '/new-user',
    element: <User />,
  },
  // {
  //   path: '/register',
  //   element: <Register />,
  // },
  {
    path: '/annotator',
    element: (
      <AuthGuard>
        <Annotator />
      </AuthGuard>
    ),
  },
  {
    path: '/annotator-v1',
    element: (
      <AuthGuard>
        <AnnotatorV1 />
      </AuthGuard>
    ),
  },
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PrimeReactProvider>
        <RouterProvider router={BrowserRouter} />
      </PrimeReactProvider>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
